export { default as ProductInfo } from './ProductInfo';
